import type {Mapping} from '../context/site-preferences.types'
import type {PreferencesResponse} from './fetchPreferences'

export const transformPreferences = <T>(
    prefs: PreferencesResponse,
    mapping: Mapping,
    label = ''
): T => {
    const result: any = {}

    for (const [groupId, mappings] of Object.entries(mapping)) {
        result[groupId] = {}

        for (const [clientKey, config] of Object.entries(mappings)) {
            const sfccGroupId = config.groupId ?? groupId
            const prefEntry = prefs.find(
                (pref) => pref.id === config.id && pref.groupId === sfccGroupId
            )

            if (prefEntry?.value !== undefined) {
                switch (config.type) {
                    case 'number':
                        result[groupId][clientKey] =
                            typeof prefEntry.value === 'number'
                                ? prefEntry.value
                                : Number(prefEntry.value) || config.defaultValue || 0
                        break
                    case 'boolean':
                        result[groupId][clientKey] =
                            prefEntry.value === 'true' ||
                            prefEntry.value === true ||
                            prefEntry.value === 1 ||
                            prefEntry.value === '1'
                        break
                    case 'string':
                    default:
                        result[groupId][clientKey] = String(prefEntry.value)
                        break
                }
            } else {
                console.error(
                    `${label} preference entry not found for id '${config.id}' in group '${groupId}'`
                )
                result[groupId][clientKey] =
                    config.defaultValue ??
                    (config.type === 'number' ? 0 : config.type === 'boolean' ? false : '')
            }
        }
    }

    return result as T
}
